import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { ImageZoomModal } from '../../common/lazy-image/image-zoom-modal';
import { IMacCardInfo } from '../../../store/mac.slice';

const makeUrl = (url: string) => {
  if (!url) return '';

  return url.startsWith('http') ? url : `${import.meta.env.VITE_REACT_APP_API_URL}/${url}`;
};

export interface IMacCardProps extends Omit<IMacCardInfo, 'selected'> {
  onZoomToggle?: (zoom: boolean) => void;
}

export const MacCard: React.FC<IMacCardProps> = ({ id, img, onZoomToggle }) => {
  const [loaded, setLoaded] = useState(false);
  const [zoomed, setZoomed] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 10);

    return () => clearTimeout(timer);
  }, [zoomed]);

  return (
    <div
      key={id}
      className={classNames('relative w-full h-full flex overflow-hidden justify-center ', {
        'flex-col': zoomed,
        'duration-800': visible && zoomed,
        'duration-200': visible && !zoomed,
        'opacity-100 transition-opacity': visible,
        'opacity-0': !visible,
      })} // Добавляем transition
    >
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <div className="w-6 h-6 border-2 border-gray-300 border-t-transparent rounded-full animate-spin" />
        </div>
      )}

      <div
        className={classNames('w-full h-full contents overflow-hidden', {
          'cursor-zoom-in': !zoomed || !onZoomToggle,
          'cursor-zoom-out': zoomed && onZoomToggle,
        })}
        onClick={() => {
          setZoomed((z) => {
            onZoomToggle && onZoomToggle(!z);

            return !z;
          });
          setVisible(false);
        }}
      >
        <img
          src={makeUrl(img)}
          className={classNames('object-contain rounded-[20px] h-full ', {
            'opacity-0': !loaded,
            'opacity-100': loaded,
          })}
          alt={`mac-${id}`}
          loading="lazy"
          onLoad={() => setLoaded(true)}
        />
      </div>
      {zoomed && !onZoomToggle && <ImageZoomModal src={makeUrl(img)} onClose={() => setZoomed(false)} />}
      {zoomed && <div className="grow-1"></div>}
    </div>
  );
};
